export const toDate = (date?: Date | string): Date | null => {
  const formattedDate = typeof date === 'string' ? date : date?.toDateString();
  return (
    date ? new Date(new Date(formattedDate as string).setHours(0, 0, 0, 0)) : null
  );
};
